export enum ResponseType {
  XML = 1,
  Json = 2,
}
